import { Controllers } from "radium-omnibus";
import React from "react";
import { useNavigate } from "react-router-dom";
import Container from "../../../components/layouts/Container";
import { ContextLanguage } from "../../../context/Context.Language";
import { TEXT_OTP, TEXT_OTP_SENT_SMS } from "../../../utils/useConstants";
import { STATE_CONSTANTS_LOGIN } from "../../../utils/useConstantState";
import {
  STYLE_ADDRESS_BG,
  STYLE_INPUT_FOOTER,
  STYLE_LINK_BLUE,
  STYLE_MAX_WIDTH_DESKTOP,
  STYLE_NUMBER_OTP,
  STYLE_PADDING_NO_MB,
  STYLE_TEXT_OTP,
} from "../../../utils/useStyle";
import ProgramGoBack from "../../task/render/Program.GoBack";
import { Auth } from "aws-amplify";
import {
  FunctionGetUsername,
  GetPhoneNumber,
} from "../../../utils/useFunction";
import api from "../../../utils/useApi";
import { initAuth, loginThunk } from "../../../redux/auth.reducer";
import { useDispatch } from "react-redux";
import LoginOnClickLogin from "../function/Login.OnClickLogin";
import LoginOtpAgain from "./Login.OTPAgain";
import FieldOTP from "../../../components/field/Field.OTP";
import { ContextCart } from "../../../context/Context.Cart";
import OurserviceFirstLoad from "../../select/functions/Ourservice.FirstLoad";

let password = "NkZ+^64&*kF5x+Wn";

const LoginOTP = ({
  username,
  setTab,
  uniqueKey,
  phoneCode,
  setMongoId,
  isNewKey,
  isFirstLogin,
  contry,
  setUserName,
  setUniqueKey,
  setIsNewKey,
  setIsFirstLogin,
  value,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { language } = React.useContext(ContextLanguage);
  const { cart } = React.useContext(ContextCart);

  console.log("LOGIN OTP ", {
    username,
    setTab,
    uniqueKey,
    phoneCode,
    setMongoId,
    isNewKey,
    isFirstLogin,
    contry,
    setUserName,
    setUniqueKey,
    setIsNewKey,
    setIsFirstLogin,
    value,
  });

  React.useEffect(() => {
    OurserviceFirstLoad();
  }, []);

  const otpReference = React.useRef([]);

  // React.useEffect(() => {
  //   onClickFinishOtp("123456");
  // }, []);

  const onClickFinishOtp = async (otp) => {
    // console.log("otp", { otp, username, contry, value });
    try {
      // await Auth.confirmSignUp(FunctionGetUsername(username), otp);
      if (!isFirstLogin) {
        // dispatch(loginThunk({ username, password }));
        const isPayment = sessionStorage.getItem("payment");
        setTimeout(() => {
          sessionStorage.removeItem("redirect");
        }, 5000);
        setTimeout(async () => {
          if (isPayment) {
            sessionStorage.removeItem("payment");
            navigate("/Basket");
          } else {
            const { data } = await api.post("/profiles/success", {
              value: username,
            });
            if (data?.success === true) {
              // navigate("/OurServices");
              dispatch(loginThunk({ username, password }));

              if (cart?.length > 0) {
                navigate("/Basket");
              } else {
                navigate("/OurServices");
              }
            } else {
              navigate("/CompleteProfile");
            }
          }
        }, 300);
        return;
      }
      if (isNewKey) {
        // await Auth.signIn(FunctionGetUsername(username), "NkZ+^64&*kF5x+Wn");
        // const user = await Auth.currentAuthenticatedUser();
        // await Auth.updateUserAttributes(user, {
        //   phone_number: `${username}`,
        //   ["custom:unique_key"]: `${uniqueKey}`,
        // });
      }
      const {
        data: { _id },
      } = await api.post("/profiles", {
        phone_number: `${username}`,
        unique_key: `${uniqueKey}`,
        username: `${FunctionGetUsername(username)}`,
        phone_code: phoneCode,
      });
      setMongoId(_id);
      dispatch(loginThunk({ username, password }));
      if (isFirstLogin) {
        navigate("/CompleteProfile");
      }
    } catch (error) {
      console.error("confirm user otp error", error);
    }
  };

  React.useEffect(() => {
    if (contry && value) {
      console.log("IN FIRST");
      async function getOtp() {
        await LoginOnClickLogin(
          setTab,
          `+${contry?.value}${GetPhoneNumber(value)}`,
          setUserName,
          setUniqueKey,
          setIsNewKey,
          setIsFirstLogin
        );
      }
      getOtp();
    }
    return () => {};
  }, [contry, value]);

  React.useEffect(() => {
    if (username) {
      console.log("IN SEC");
      onClickFinishOtp("123456");
    }
  }, [username]);

  return (
    <div className={`mb-10`}>
      <Container>
        <div className={`${STYLE_MAX_WIDTH_DESKTOP} ${STYLE_PADDING_NO_MB}`}>
          <div className={STYLE_ADDRESS_BG}>
            <ProgramGoBack
              title={TEXT_OTP[language]}
              onClick={() => {
                setTab(STATE_CONSTANTS_LOGIN.PHONE_NUMBER);
              }}
              // textcolor=" col-span-4 xl:col-span-1  "
            />

            <div className=" mt-5.5 mb-4  md:mt-6.5 ">
              <div className={STYLE_TEXT_OTP}>
                {TEXT_OTP_SENT_SMS[language]}
              </div>
              <div className={STYLE_NUMBER_OTP}>{username}</div>
              <div className="">
                {/* <Controllers
                  classNameSuperCore=" flex justify-center  mt-4 md:my-6 w-full  "
                  fields={[
                    {
                      name: "otp",
                      type: "otp",
                      trigger: (otp) => {
                        onClickFinishOtp(otp);
                      },
                      count: 6,
                      classNameInput: (props) => {
                        if (props?.inputIndex < 5) {
                          return " mr-3 w-w_47 h-h_66  md:w-w_52 shadow-none border-none  rounded-lg bg-white focus:outline-none ring-1 ring-laudry-stroke appearance-none focus:ring-laundry-primary-blue text-center text-32 leading-8.3 font-medium font-Poppins  ";
                        } else {
                          return " w-w_47 h-h_66  md:w-w_52 shadow-none  border-none  rounded-lg bg-white focus:outline-none ring-1 ring-laudry-stroke appearance-none focus:ring-laundry-primary-blue text-center text-32 leading-8.3 font-medium font-Poppins";
                        }
                      },
                    },
                  ]}
                /> */}
                <Controllers
                  classNameSuperCore=" flex justify-center  mt-4 md:my-6 w-full  "
                  fields={[
                    {
                      name: "otp",
                      type: "customs",
                      fieldCustoms: (props) => {
                        props = {
                          ...props,
                          otpReference: otpReference,
                          classNameInput: (props) => {
                            if (props?.inputIndex < 5) {
                              return " mr-3 w-[42px] h-h_66  md:w-w_52 shadow-none border-none  rounded-lg bg-white focus:outline-none ring-1 ring-laudry-stroke bg-transparent  text-black opacity-100   placeholder-laundry-gray-50 appearance-none  focus:ring-laundry-primary-blue text-center text-32 leading-8.3 font-medium font-Poppins  ";
                            } else {
                              return " w-[42px] h-h_66  md:w-w_52 shadow-none  border-none  rounded-lg bg-white focus:outline-none ring-1 ring-laudry-stroke  bg-transparent  text-black opacity-100  placeholder-laundry-gray-50  appearance-none  focus:ring-laundry-primary-blue text-center text-32 leading-8.3 font-medium font-Poppins";
                            }
                          },

                          trigger: (otp) => {
                            onClickFinishOtp(otp);
                          },
                        };

                        return <FieldOTP props={props} />;
                      },
                      // trigger: (otp) => {
                      //   onClickFinishOtp(otp);
                      // },
                      // count: 6,
                      // classNameInput: (props) => {
                      //   if (props?.inputIndex < 5) {
                      //     return " mr-3 w-w_47 h-h_66  md:w-w_52 shadow-none border-none  rounded-lg bg-white focus:outline-none ring-1 ring-laudry-stroke appearance-none focus:ring-laundry-primary-blue text-center text-32 leading-8.3 font-medium font-Poppins  ";
                      //   } else {
                      //     return " w-w_47 h-h_66  md:w-w_52 shadow-none  border-none  rounded-lg bg-white focus:outline-none ring-1 ring-laudry-stroke appearance-none focus:ring-laundry-primary-blue text-center text-32 leading-8.3 font-medium font-Poppins";
                      //   }
                      // },
                    },
                  ]}
                />
              </div>{" "}
            </div>

            <LoginOtpAgain
              username={username}
              value={value}
              contry={contry}
              otpReference={otpReference}
            />
          </div>
        </div>
      </Container>
    </div>
  );
};
export default LoginOTP;
